import React from "react";
import { ExportPrint, IconWrap, ExtraContentWrap } from "./styles";
import exportImg from "./../../../../assets/icons/export.svg";
import { initiateTracking, recordError } from './../../../../utils/commonUtil';
import { tabNameHandler } from "./../../Pages/txnUitls";

export class ExportContent extends React.Component {

	handleAnalytics = (activeKey) => {
		try {
			const tabName = tabNameHandler(activeKey);
			initiateTracking('export', this.props.pageTitle, 'Transactional Details', `Export - ${tabName.analytics}`);
			this.props.onClick()
		} catch (error) {
			recordError(error);
		}
	}

	render() {
		return (
			<ExtraContentWrap data-test="transaction-export-content">
				<IconWrap marginRight="3px">
					<img className="eImage" src={exportImg} alt="Export" /> &nbsp;
         </IconWrap>
				<ExportPrint onClick={() => this.handleAnalytics(this.props.activeKey)}>EXPORT</ExportPrint>
			</ExtraContentWrap>
		)
	}
}

export default ExportContent;